export enum CancellationFlow {
    withCancellingOffer = 'PROCEED_WITH_CANCELLING_OFFER',
    withSupport = 'PROCEED_WITH_SUPPORT',
    withPlanSuggestion = 'PROCEED_WITH_PLAN_SUGGESTION',
    withPauseSubscription = 'PROCEED_WITH_PAUSE_SUBSCRIPTION',
    withReminderOffer = 'PROCEED_WITH_REMINDER_OFFER',
    withFeedbackForm = 'PROCEED_WITH_FEEDBACK_FORM',
}

export interface ICancellationReasonModal {
    onSubmit: (reason: { reason: IReason | null }) => void;
    onCancel: (reason: { reason: IReason | null }) => void;
    onClose: () => void;
    trackLoad?: () => void;
    captions: {
        headerTitle: string;
        additionalInfo?: {
            title: string;
            text: string;
        };
        title: string;
        submitButton: string;
        discardButton?: string;
    };
    isCaliforniaFlow?: boolean;
}

export interface IUserFeedback {
    reason: IReason | null;
}

export interface IReason {
    title: string;
    shortKey: string;
    flow: string;
    preselected?: boolean;
}
